<template>
  <div class="spec-Item-normal-container">
    <el-row :gutter="20" type="flex" justify="space-between">
      <el-col :span="4">
        <el-input :value="item.specType" @input="specTypeChange" placeholder="请输入规格项" size="mini" :disabled="isOA"></el-input>
      </el-col>
      <el-col :span="18">
        <template v-for="(tag, index) in item.specValue">
          <el-tag
            :key="tag"
            v-if="showInputEditIndex !== index"
            :closable="!isOA"
            :disable-transitions="false"
            @close="handleClose(tag)"
            @click="showInputEdit(tag, index)"
          >
            {{ tag }}
          </el-tag>
        </template>
        <template v-if="item.specType.length && !isOA">
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加规格值</el-button>
        </template>
      </el-col>
      <el-col :span="2">
        <el-button v-if="!isOA" type="text" @click="$emit('deleteSpecItemEvent', item)">删除</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
    },
    specList: {
      type: Array,
    },
    isOA: {
      type: Boolean,
    },
  },
  data() {
    return {
      inputVisible: false,
      inputValue: "",
      showInputEditIndex: "",
      isInputEdit: false,
    };
  },
  watch: {
    "item.specType": function (newVal) {
      if (newVal.length == 0) {
        this.item.specValue = [];
      }
    },
  },
  methods: {
    specTypeChange(val) {
      const found = this.specList.find((item) => item.specType === val);

      if (val && found) {
        this.$message.error("规格项不可重复");
        return;
      }
      this.item.specType = val;
    },
    handleClose(tag) {
      this.item.specValue.splice(this.item.specValue.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    showInputEdit(tag, index) {
      if (this.isOA) {
        return;
      }
      this.isInputEdit = true;
      this.inputVisible = true;
      this.showInputEditIndex = index;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.value = tag;
        this.$refs.saveTagInput.$refs.input.focus();
        this.inputValue = tag;
      });
      // this.handleClose(tag);
    },

    handleInputConfirm() {
      let { item, inputValue, isInputEdit, showInputEditIndex } = this;

      if(inputValue.indexOf(' ') !== -1){
        this.$message.error("规格值不能包含空格");
        return
      }
      if (inputValue) {
        if (isInputEdit) {
          const findIndex = item.specValue.findIndex((item) => item == inputValue);
          if (findIndex != -1 && showInputEditIndex !== findIndex) {
            this.$message.error("规格值不可重复");
          }
          if (inputValue !== item.specValue[showInputEditIndex]) {
            this.$set(item.specValue, showInputEditIndex, inputValue);
          }

          this.isInputEdit = false;
          this.showInputEditIndex = "";
        } else if (item.specValue.indexOf(inputValue) != -1 && this.showInputEditIndex === "") {
          this.$message.error("规格值不可重复");
        } else {
          this.item.specValue.push(inputValue);
          this.showInputEditIndex = "";
        }
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.spec-Item-normal-container {
  margin-top: 15px;
  padding: 5px;
  background-color: rgb(242, 242, 242);
  border-radius: 10px;
  .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 180px;
    margin-left: 10px;
    vertical-align: bottom;
  }
}
</style>
